export default {
  "content": "<rect width=\"40\" height=\"40\" rx=\"20\" fill=\"#F2F2F2\"/><path d=\"M20 9a11 11 0 100 22 11 11 0 000-22zm0 20a9 9 0 110-17.999A9 9 0 0120 29zm2-14v-1a1 1 0 00-2 0v1h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v6h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1v1a1 1 0 002 0v-1a3 3 0 003-3 3 3 0 00-.77-2 3 3 0 00.77-2 3 3 0 00-3-3zm0 8h-3v-2h3a1 1 0 010 2zm0-4h-3v-2h3a1 1 0 010 2z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "40",
    "height": "40",
    "viewBox": "0 0 40 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};